/** Phase-3 content: arcade minigames (all original designs). */
export const enArcade = {
  arcade: {
    title: '🕹️ Arcade',
    hint: 'Pick a game! Good scores earn stars (a few per game each day).',
    play: '▶ Play',
    again: '🔁 Play again',
    back: '⬅ Games',
    score: 'Score',
    best: 'Best',
    over: 'Game over!',
    win: 'You win!',
    earned: (n: number) => `+${n}⭐ earned`,
    capped: 'Daily stars for this game already earned — play for fun!',
    tap: 'Tap to start',
    games: {
      volleyball: { name: 'Volley Rally', how: 'Move ◀ ▶ under the ball and press ● to bump it over the net. Don’t let it drop!' },
      tennis: { name: 'Tennis Swing', how: 'Move ◀ ▶ to the ball and press ● when it reaches you to hit it back.' },
      rhythm: { name: 'Piano Rhythm', how: 'Tap the lane when a note reaches the line. Each hit plays a note!' },
      drawing: { name: 'Sketchbook', how: 'Draw with your finger. Pick colours and brushes, then share it on PixelBook!' },
      racing: { name: 'Street Racer', how: 'Steer ◀ ▶ to dodge traffic and grab coins. It gets faster!' },
      circus: { name: 'Circus Juggler', how: 'Press ◀ or ▶ when a ball reaches that hand to toss it again.' },
      minesweeper: { name: 'Mine Garden', how: 'Tap to dig. Numbers count hidden moles nearby. Use 🚩 mode to mark them.' },
      snake: { name: 'Hungry Caterpillar', how: 'Steer with arrows or swipes. Eat leaves to grow, don’t bite yourself!' },
      baseball: { name: 'Home Run Derby', how: 'Press ● to swing when the ball reaches the plate. Perfect timing = home run!' },
      maze: { name: 'Firefly Garden', how: 'Fly through the hedge maze collecting light. Glowing flowers make the frogs sleep!' },
      match3: { name: 'Fruit Swap', how: 'Swap two neighbouring fruits to line up 3 or more. 25 moves!' },
      puzzle: { name: 'Sliding Puzzle', how: 'Put the tiles in order 1–8.' },
      blocks: { name: 'Block Stack', how: 'Clear lines with falling blocks.' },
      goldfish: { name: 'Goldfish Scoop', how: 'Dip the paper scoop under a fish and lift it out. Move gently or the paper tears! Gold fish = 3.' },
      ringToss: { name: 'Ring Toss', how: 'Aim ◀ ▶, hold ● (or the screen) and let go when the power is right. 10 rings!' },
      claw: { name: 'Claw Machine', how: 'Move the claw ◀ ▶ (or drag), press ● to drop it and carry a plush to the chute. 5 plays!' },
      dragonBoat: { name: 'Dragon Boat Race', how: 'Tap ◀ ▶ in turn, on the drum beat, to paddle. At the finish, press ● to grab the flag!' },
      stoneStack: { name: 'Pebble Tower', how: 'Tap to drop the swinging pebble onto the stack. Keep it balanced — watch the wind!' },
    },
    drawing: {
      prompt: 'Today’s idea:',
      prompts: ['a cat', 'your family', 'a cherry tree', 'your dream house', 'a rainy day', 'your best friend', 'a monster'],
      clear: '🗑️',
      eraser: '🧽',
      share: '📤 Share on PixelBook',
      shared: 'Shared! Your friends love it.',
    },
    mines: { dig: '⛏️ Dig', flag: '🚩 Flag', left: (n: number) => `🐹 ${n} left` },
  },
};
